/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyApiKeyManagement: LazyComponent<() => React.JSX.Element> = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-api-key-management", jiraSpaEntry: "async-jira-eoc-api-key-management" */ '@jira/eoc__api-key-management/src/index.tsx'
		),
);

const AsyncApiKeyManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyApiKeyManagement}
		pageId="async-jira-eoc-api-key-management"
		shouldShowSpinner={false}
	/>
);

export default AsyncApiKeyManagement;
